export default "__VITE_ASSET__c4a2a6da__$_?nuxt_component=async&nuxt_component_name=SvgoPhone__"